/* SSL hero gallery — Agentcy for SickScience */
(() => {
  class SslGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ssl-gallery__track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.thumbRow = this.querySelector('.ssl-gallery__thumbs');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.count = this.querySelector('[data-count]');
      if (!this.track || !this.slides.length) return;
      this.index = -1;

      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.go(i)));
      this.prev?.addEventListener('click', () => this.go(this.index - 1));
      this.next?.addEventListener('click', () => this.go(this.index + 1));

      let frame;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => this.sync());
      }, { passive: true });

      this.track.addEventListener('keydown', (e) => {
        if (e.target.matches('input, select, textarea')) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
      });

      this.sync();
    }

    go(i) {
      const n = Math.max(0, Math.min(this.slides.length - 1, i));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.slides[n].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    sync() {
      const width = this.track.clientWidth || 1;
      const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
      if (i === this.index) return;
      this.index = i;
      this.thumbs.forEach((thumb, t) => {
        if (t === i) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      const active = this.thumbs[i];
      if (active && this.thumbRow) {
        const left = active.offsetLeft - (this.thumbRow.clientWidth - active.offsetWidth) / 2;
        this.thumbRow.scrollTo({ left: Math.max(0, left) });
      }
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
      if (this.count) this.count.textContent = `${i + 1} / ${this.slides.length}`;
    }
  }

  if (!customElements.get('ssl-gallery')) customElements.define('ssl-gallery', SslGallery);
})();
